import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import TotalSummariesItem from "@/components/platform/TotalSummariesItem.vue";
var TotalSummaries = /*#__PURE__*/function (_Vue) {
  function TotalSummaries() {
    _classCallCheck(this, TotalSummaries);
    return _callSuper(this, TotalSummaries, arguments);
  }
  _inherits(TotalSummaries, _Vue);
  return _createClass(TotalSummaries, [{
    key: "nbSpeachPublish",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbSpeachPublish');
    }
  }, {
    key: "nbNewSpeachWeek",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbNewSpeachWeek');
    }
  }, {
    key: "nbNewSpeachMonth",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbNewSpeachMonth');
    }
  }, {
    key: "nbSpeachesToValidate",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbSpeachToValidate');
    }
  }, {
    key: "nbUser",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbUser');
    }
  }, {
    key: "nbSpeachMaker",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbSpeachMaker');
    }
  }, {
    key: "nbAdmins",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbAdmin');
    }
  }, {
    key: "nbUserConnected",
    get: function get() {
      return this.sumSummariesGivenDataAttribute('nbConnectedMonth');
    }
  }, {
    key: "sumSummariesGivenDataAttribute",
    value: function sumSummariesGivenDataAttribute(attribute) {
      var summaries = store.getters.summaries;
      var total = 0;
      for (var value in summaries) {
        if (summaries[value] !== undefined) {
          var summary = summaries[value];
          total += Number(summary[attribute]);
        }
      }
      return total;
    }
  }]);
}(Vue);
TotalSummaries = __decorate([Options({
  components: {
    TotalSummariesItem: TotalSummariesItem
  }
})], TotalSummaries);
export default TotalSummaries;